// extracted by mini-css-extract-plugin
module.exports = {"page":"CompanyPage_page__d6U0I"};